"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.mouseEvents = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Ink = _interopRequireDefault(require("../Ink"));

var _prepareInputName = _interopRequireDefault(require("../_utils/prepareInputName"));

require("./check.sass");

var mouseEvents = ['onClick', 'onMouseDown', 'onMouseUp', 'onMouseMove'];
exports.mouseEvents = mouseEvents;

var _ref = _react.default.createElement("svg", {
  className: "check-box-icon",
  viewBox: "0 0 16 16",
  width: "16px",
  height: "16px"
}, _react.default.createElement("path", {
  className: "check-box-icon-empty",
  d: "M 14.4 0 L 1.6 0 C 0.712 0 0 0.712 0 1.6 L 0 14.4 C 0 15.284 0.716 16 1.6 16 L 14.4 16 C 15.284 16 16 15.284 16 14.4 L 16 1.6 C 16 0.712 15.28 0 14.4 0 Z  M 14 2 L 14 14 L 2 14 L 2 2 L 14 2 Z",
  fill: "currentColor"
}), _react.default.createElement("path", {
  className: "check-box-icon-check",
  d: "M 14.4 0 L 1.6 0 C 0.712 0 0 0.712 0 1.6 L 0 14.4 C 0 15.284 0.716 16 1.6 16 L 14.4 16 C 15.284 16 16 15.284 16 14.4 L 16 1.6 C 16 0.712 15.28 0 14.4 0 Z  M 12.736 2.88 L 14.4 4.288 L 5.44 12.992 L 4.8 12.352 L 1.6 9.152 L 3.008 7.744 L 5.44 10.176 L 12.736 2.88 Z",
  fill: "currentColor"
}), _react.default.createElement("path", {
  className: "check-box-icon-minus",
  d: "M 14.4 0 L 1.6 0 C 0.712 0 0 0.712 0 1.6 L 0 14.4 C 0 15.284 0.716 16 1.6 16 L 14.4 16 C 15.284 16 16 15.284 16 14.4 L 16 1.6 C 16 0.712 15.28 0 14.4 0 Z  M 13.333 9.067 L 2.667 9.067 L 2.667 6.933 L 13.333 6.933 L 13.333 9.067 Z ",
  fill: "currentColor"
}));

var Check =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(Check, _React$PureComponent);

  function Check() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Check);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Check)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {
      isFocus: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onFocus", function (e) {
      _this.setState({
        isFocus: true
      });

      _this.props.onFocus && _this.props.onFocus(e);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onBlur", function (e) {
      _this.setState({
        isFocus: false
      });

      _this.props.onBlur && _this.props.onBlur(e);
    });
    return _this;
  }

  (0, _createClass2.default)(Check, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          greyscale = _this$props.greyscale,
          className = _this$props.className,
          indeterminate = _this$props.indeterminate,
          noInk = _this$props.noInk,
          checked = _this$props.checked,
          name = _this$props.name,
          parrentRef = _this$props.parrentRef,
          inputProps = (0, _objectWithoutProperties2.default)(_this$props, ["children", "greyscale", "className", "indeterminate", "noInk", "checked", "name", "parrentRef"]);
      var labelProps = {
        className: (0, _classnames.default)('check', {
          'check--disabled': inputProps.disabled
        }, className)
      };

      if (checked != null) {
        inputProps.checked = checked;

        inputProps.ref = function (el) {
          if (el) {
            el.indeterminate = !checked && indeterminate;
            parrentRef && parrentRef(el);
          }
        };
      } else if (parrentRef) {
        inputProps.ref = parrentRef;
      }

      mouseEvents.forEach(function (eventName) {
        if (inputProps[eventName]) {
          labelProps[eventName] = inputProps[eventName];
          delete inputProps[eventName];
        }
      });
      return _react.default.createElement("label", labelProps, _react.default.createElement("input", (0, _extends2.default)({
        type: "checkbox",
        className: "check-input",
        name: (0, _prepareInputName.default)(name),
        onFocus: this.onFocus,
        onBlur: this.onBlur
      }, inputProps)), _react.default.createElement("span", {
        className: (0, _classnames.default)('check-box', {
          'check-box--greyscale': greyscale
        })
      }, _ref, inputProps.disabled || inputProps.readOnly || noInk ? null : _react.default.createElement(_Ink.default, {
        primary: true,
        focused: this.state.isFocus
      })), children && _react.default.createElement("span", {
        className: "check-label"
      }, children));
    }
  }]);
  return Check;
}(_react.default.PureComponent);

Check.propTypes = process.env.NODE_ENV !== "production" ? {
  name: _propTypes.default.string,
  className: _propTypes.default.string,
  greyscale: _propTypes.default.bool,
  indeterminate: _propTypes.default.bool,
  checked: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  onClick: _propTypes.default.func,
  onMouseDown: _propTypes.default.func,
  onMouseUp: _propTypes.default.func,
  onMouseMov: _propTypes.default.func
} : {};
var _default = Check;
exports.default = _default;